import { Link } from 'react-router';

export default function ProjectNotFound() {
  return (
    <div className='h-full px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8'>
      <div className='max-w-max mx-auto'>
        <main className='sm:flex'>
          <p className='text-4xl font-extrabold text-neutralColor-dark sm:text-5xl'>
            4<span style={{ color: '#0FCA98' }}>0</span>4
          </p>
          <div className='sm:ml-6'>
            <div className='sm:border-l sm:border-gray-200 sm:pl-6'>
              <h1 className='text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl'>Oops! Project not found</h1>
              <p className='mt-1 text-base text-gray-500'>The project you are looking for does not exist. Please try another project</p>
            </div>
            <div className='mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6'>
              <Link
                to='/app/sherpa/projects'
                className='inline-flex items-center px-4 py-2 border border-transparent text-sm font-semibold rounded-md shadow-sm text-white bg-primaryColor-normal hover:bg-priamryColor-medium focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-primaryColor-normal'
              >
                List Projects
              </Link>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
